export const getPercentageFromTotal = (total: number, fraction: number) =>
  (fraction * 100) / total + '%';
